import { computed, Ref } from '@vue/composition-api';
import { ContentReaction, ReactionType } from '@front-app/services/GroupsApi/DiscussionModel';
import { CurrentUserStore } from '@front-app/store/singletons/User';

export interface ReactionButton {
	key: string | number;
	type: ReactionType;
	icon: String;
	count: number;
	hasCurrentUserReacted: boolean;
}

export const REACTION_BUTTON_ICONS: Record<ReactionType, String> = {
	[ReactionType.LIKE]: '👍',
	[ReactionType.HAPPY]: '😀',
	[ReactionType.LAUGH]: '😂',
	[ReactionType.CLAP]: '👏',
	[ReactionType.FOLDED_HANDS]: '🙏',
	[ReactionType.SAD]: '🙁',
}

export interface UseReactionButtons {
	allReactionButtons: Ref<ReactionButton[]>;
	reactionButtons: Ref<ReactionButton[]>;
}

export const useReactionButtons = (reactions: Ref<ContentReaction[]>): UseReactionButtons => {
	const currentUserId = CurrentUserStore.currentUser.value.id;

	const allReactionButtons = computed(() => Object.values(ReactionType)
		.map((reactionType) => ({
			key: reactionType,
			type: ReactionType[reactionType],
			icon: REACTION_BUTTON_ICONS[reactionType],
			count: 0,
			hasCurrentUserReacted: false,
		})));

	const reactionButtons = computed(() => Object.values(ReactionType)
		.map((reactionType) => ({
			key: reactionType,
			type: ReactionType[reactionType],
			icon: REACTION_BUTTON_ICONS[reactionType],
			count: countReactions(reactionType, reactions.value),
			hasCurrentUserReacted: checkIfUserHasReacted(currentUserId, reactionType, reactions.value),
		})));

	return {
		allReactionButtons,
		reactionButtons,
	};
};

function countReactions(reactionType: ReactionType, reactions: ContentReaction[]) {
	let count = 0;
	reactions.forEach((reaction) => {
		if (reaction.reactionType === reactionType) {
			count++;
		}
	})
	return count;
}

function checkIfUserHasReacted(currentUserId: string, reactionType: ReactionType, reactions: ContentReaction[]) {
	for (let reaction of reactions) {
		if (reaction.reactionType === reactionType && reaction.userId === currentUserId) {
			return true;
		}
	}
	return false;
}
